/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { useNavigate, createSearchParams } from "react-router-dom";
import { urlLoginUsuario, apiUrl } from "../../../utils/constants";
import axiosClient from "../../../utils/axiosClient";
import {
  IonButton,
  IonInput,
  IonItem,
  IonLabel,
  IonText,
  IonCard,
  IonContent,
  IonToast,
  IonActionSheet,
  IonLoading,
} from "@ionic/react";

import Lottie from "lottie-react";
import loginAnimation from "./login.json";
export default function LoginUsuario() {
  const navigate = useNavigate();
  const [codigo, setcodigo] = useState(55);
  const [ddd, setDDD] = useState("");
  const [numero, setNumero] = useState("");
  const url = window.location.href;
  const urlBase = new URL(url);
  const empresaParms = urlBase.searchParams.get("empresa");

  const [colorToast, setColorToast] = useState("");
  const [iconToast, setIconToast] = useState("");
  const [mensagemToast, setMensagemToast] = useState("");
  const [tempoToast, setTempoToast] = useState("");
  const [textoToast, setTextoToast] = useState("");
  const [statusToast, setStatusToast] = useState(false);

  const [actionSheetNumero, setActionSheetNumero] = useState(false);

  const [loading, setLoading] = useState(false);

  const fazerLogin = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.post(urlLoginUsuario, {
        codigo: codigo,
        ddd: ddd,
        telefone: numero,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.status == "1") {
        localStorage.setItem("email_usuario_agendou", response.data.email);
        navigate({
          pathname: "/usuarios/codigo_verificacao",
          search: createSearchParams({
            codigo_existe: response.data.codigo_existe,
            data_codigo: response.data.data_codigo,
            expiracao_codigo: response.data.expiracao_codigo
          }).toString(),
        });
        setLoading(false);
      } else if (response.data.status == "2") {
        localStorage.setItem("codigo", codigo);
        localStorage.setItem("DDD", ddd);
        localStorage.setItem("numero", numero);
        if (empresaParms !== null) {
          navigate({
            pathname: "/usuarios/cadastrar",
            search: createSearchParams({
              empresa: empresaParms,
            }).toString(),
          });
        } else {
          navigate({
            pathname: "/usuarios/cadastrar",
          });
        }
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const verificarCampos = async () => {
    if (ddd.length < 2) {
      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast("Seu DDD precisa ter 2 dígitos");
      setTempoToast(10000);
      setTextoToast("Ok");
      setStatusToast(true);
      return;
    }

    if (ddd.length > 2) {
      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast("Seu DDD precisa ter 2 dígitos");
      setTempoToast(10000);
      setTextoToast("Ok");
      setStatusToast(true);
      return;
    }

    if (numero.length < 9) {
      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast("Seu número precisa ter 9 dígitos");
      setTempoToast(10000);
      setTextoToast("Ok");
      setStatusToast(true);
      return;
    }

    if (numero.length > 9) {
      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast("Seu número precisa ter 9 dígitos");
      setTempoToast(10000);
      setTextoToast("Ok");
      setStatusToast(true);
      return;
    }

    setActionSheetNumero(true);
  };

  const irParaCadastro = () => {
    if (empresaParms !== null) {
      navigate({
        pathname: "/usuarios/cadastrar",
        search: createSearchParams({
          empresa: empresaParms,
        }).toString(),
      });
    } else {
      navigate({
        pathname: "/usuarios/cadastrar",
      });
    }
  };

  useEffect(() => {
    const verificaSessao = async () => {
      try {
        const response = await axiosClient.post(
          apiUrl + "usuarios/sessao/sessao",
          {},
        );
        if (response.data === 1) {
          navigate({
            pathname: "/usuarios/inicio",
          });
        }
      } catch (error) {
        return null;
      }
    };
    verificaSessao();
  }, []);

  return (
    <IonContent>
      <IonLoading isOpen={loading} message="Aguarde..." duration={30000} />
      <div className="ion-margin">
        <div className="row">
          <div className="col-sm-4"></div>
          <div className="col-sm-4">
            <IonCard>
              <div className="ion-margin centro" name="logarusuario">
                <div style={{ margin: "1%" }}></div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "20px",
                  }}
                >
                  <Lottie
                    animationData={loginAnimation}
                    style={{ width: 600, height: 150 }}
                  />
                </div>

                <h2 className="nomeDoApp"></h2>

                <IonText color="medium">
                  <p className="IonText-center">
                    Preencha os campos abaixo para continuar
                  </p>
                </IonText>

                <IonItem>
                  <IonLabel position="stacked">Código do país: </IonLabel>
                  <IonInput
                    type="tel"
                    className="codigo"
                    maxlength={"5"}
                    minlength={"2"}
                    placeholder="Código do país"
                    onIonInput={(event) => {
                      event.preventDefault();
                      setcodigo(event.target.value);
                    }}
                    value={codigo}
                  />
                </IonItem>

                <IonItem>
                  <IonLabel position="stacked">DDD: </IonLabel>
                  <IonInput
                    type="tel"
                    maxlength={"2"}
                    minlength={"2"}
                    className="ddd"
                    placeholder="Digite seu DDD"
                    onIonInput={(event) => {
                      event.preventDefault();
                      setDDD(event.target.value);
                    }}
                    value={ddd}
                  />
                </IonItem>

                <IonItem>
                  <IonLabel position="stacked">Número: </IonLabel>
                  <IonInput
                    type="tel"
                    maxlength={"9"}
                    minlength={"9"}
                    className="numero"
                    placeholder="Digite seu número"
                    onIonInput={(event) => {
                      event.preventDefault();
                      setNumero(event.target.value);
                    }}
                    value={numero}
                  />
                </IonItem>

                <IonButton
                  color="secondary-light"
                  onClick={verificarCampos}
                  expand="full"
                  className="botaoLogar"
                >
                  Entrar &nbsp; <i className="ri-shield-check-line"></i>
                </IonButton>

                <IonText>
                  <p>Ainda não tem conta?</p>
                </IonText>

                <IonButton
                  color="light"
                  onClick={irParaCadastro}
                  expand="full"
                  className=""
                >
                  Cadastre-se &nbsp; <i className="ri-shield-check-line"></i>
                </IonButton>
              </div>
            </IonCard>
          </div>

          <div className="col-sm-4"></div>
        </div>
      </div>

      <IonActionSheet
        isOpen={actionSheetNumero}
        header={`O número +${codigo} ${ddd} ${numero} está correto?`}
        buttons={[
          {
            text: "Sim",
            role: "destructive",
            handler: () => fazerLogin(),
          },
          {
            text: "Fechar",
            role: "cancel",
            handler: () => {},
          },
        ]}
        onDidDismiss={() => setActionSheetNumero(false)}
      ></IonActionSheet>

      <IonToast
        isOpen={statusToast}
        color={colorToast}
        icon={iconToast}
        message={mensagemToast}
        onDidDismiss={() => setStatusToast(false)}
        duration={tempoToast}
        buttons={[
          {
            text: textoToast,
            role: "info",
            handler: () => {
              return;
            },
          },
        ]}
      ></IonToast>
    </IonContent>
  );
}
